import { t } from '../i18n';

// eslint-disable-next-line import/prefer-default-export
export const main = {
    menuItems: [
        { title: t('WHO_WE_ARE'), link: 'kikvagyunk' },
        { title: t('THE_PROBLEM'), link: 'problema' },
        { title: t('SOL_EC_NAV'), link: 'szolidaris-gazdasag' },
        { title: t('OUR_PROJECTS'), link: 'projektjeink' },
        { title: t('CONTACT'), link: 'kapcsolat' },
    ],
    title: t('SZGK'),
};
